import ZUserupload from './user-upload.vue'

export default ZUserupload